module.exports = __webpack_public_path__ + "c_static/img/京东付款截图.579c4d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/京东付款截图.jpg
// module id = sb13
// module chunks = 33